module.exports = __webpack_public_path__ + "img/fourday_ps_27.f07cded8.jpg";